import Base from "@/controllers/base";
export default class TruckerEmail extends Base {
  constructor(elem) {
    super(elem);
  }

  async download(event) {
    try {
      event.preventDefault();
      const form = event.target.closest("form");
      const formData = new FormData(form);
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set("format", "pdf");

      const response = await fetch(url.toString(), {
        method: form.method,
        body: formData,
        headers: {
          "X-CSRF-Token": this.authenticityToken,
          Accept: "application/pdf",
        },
      });

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const contentDisposition =
        response.headers.get("content-disposition") || "";
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
      const category =
        formData.get("trucker_email[category]") || "trucker_email";
      const filename = filenameMatch
        ? filenameMatch[1].trim()
        : `${category}.pdf`;

      const file = window.URL.createObjectURL(await response.blob());
      const link = document.createElement("a");
      link.setAttribute("href", file);
      link.setAttribute("download", filename);
      link.click();
      window.URL.revokeObjectURL(file);
    } catch (ex) {
      console.log(ex);
    }
  }
}
